import React from 'react';
import InfoTileIcon from './InfoTileIcon';
import { useTheme } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';
import ActionCTA from '../../../../sharedcomponents/sweepr-action-cta/ActionCTA';
import { getTileImage } from './infoTile.util';
import styles from './style';

/**
 * @name InfoTile - Banner component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns InfoTile Element
 */
const InfoTile = props => {
    const theme = useTheme();
    const {
        infoTileMobile,
        infoTileDesktop,
        infoTileTablet,
        infoTileForegroundDesktop,
        infoTileForegroundMobile,
        infoTileForegroundTablet,
    } = getTileImage(props);
    const classes = styles({
        theme,
        infoTileMobile,
        infoTileDesktop,
        infoTileTablet,
        infoTileForegroundDesktop,
        infoTileForegroundMobile,
        infoTileForegroundTablet,
    });

    return (
        <Grid
            container
            className={
                props.cmsData?.Info_Tile_Images?.length > 0
                    ? classes.InfoContainer
                    : classes.InfoCenterAlign
            }
        >
            <Grid
                item
                xs={12}
                sm={props.cmsData?.Info_Tile_Images?.length > 0 ? 6 : 12}
                md={props.cmsData?.Info_Tile_Images?.length > 0 ? 6 : 12}
                className={classes.InfoDetails}
            >
                <Box
                    className={
                        props.cmsData?.Info_Tile_Images?.length > 0
                            ? classes.InfoBox
                            : classes.InfoBoxCenter
                    }
                >
                    {props.cmsData?.icon?.data && props.cmsData?.Info_Tile_Images?.length === 0 && (
                        <InfoTileIcon icon={props?.cmsData?.icon} />
                    )}
                    <Box
                        className={
                            props.cmsData?.Info_Tile_Images?.length > 0
                                ? classes.infoText
                                : classes.infoTextAlign
                        }
                    >
                        <Typography component='p' variant='h2' className={classes.InfoTitle}>
                            {props?.cmsData?.title}
                        </Typography>
                        <Typography
                            component='p'
                            variant='body1'
                            className={classes.InfoDescription}
                        >
                            {props?.cmsData?.description}
                        </Typography>
                        <Box className={classes.InfoCTA}>
                            <ActionCTA
                                cta={props?.cmsData?.Info_Tile_CTAs}
                                handleAction={props?.handleAction}
                            />
                        </Box>
                    </Box>
                </Box>
            </Grid>
            {props.cmsData?.Info_Tile_Images?.length > 0 && (
                <Grid item xs={12} sm={6} md={6} className={classes.ForegroundImageContainer}>
                    <Box className={classes.ForegroundImage} />
                </Grid>
            )}
        </Grid>
    );
};
InfoTile.displayName = 'InfoTile';
export default InfoTile;
